import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13 6.5H5v1l4 4 4-4z"
	})
});
export default SvgTriangleDown;
